import React from 'react';

// S-марка InfoScale — та же, что на лендинге (PIN-307). Буква S закривлена
// в контур из JetBrains Mono Medium (500): пиксель-в-пиксель с infoscale.ru
// и никакой зависимости от загрузки шрифта. Цвета кружка и буквы задаёт CSS
// (.uh-brand-mark, инверсия на тёмном сайдбаре — в theme.css).
const S_MARK_PATH = 'M38.19 55.48Q33.01 55.48 29.94 52.77Q26.86 50.06 26.86 45.3H31.62Q31.62 48.09 33.39 49.67Q35.17 51.26 38.19 51.26Q41.07 51.26 42.78 49.65Q44.48 48.04 44.48 45.35Q44.48 43.34 43.38 41.82Q42.27 40.31 40.26 39.78L35.07 38.39Q31.66 37.43 29.67 34.91Q27.68 32.39 27.68 28.94Q27.68 26.1 28.95 23.97Q30.22 21.83 32.53 20.66Q34.83 19.48 37.86 19.48Q40.93 19.48 43.26 20.66Q45.58 21.83 46.88 23.94Q48.18 26.06 48.18 28.84H43.47Q43.47 26.54 41.91 25.1Q40.35 23.66 37.86 23.66Q35.36 23.66 33.85 25.1Q32.34 26.54 32.34 28.84Q32.34 30.71 33.34 31.98Q34.35 33.26 36.18 33.78L41.5 35.22Q45.1 36.18 47.12 38.9Q49.14 41.61 49.14 45.35Q49.14 48.42 47.79 50.7Q46.45 52.98 43.98 54.23Q41.5 55.48 38.19 55.48Z';

const BrandMark = ({ size = 24 }) => (
  <svg className="uh-brand-mark" viewBox="0 0 76 76" width={size} height={size} aria-hidden="true">
    <circle cx="38" cy="38" r="27" fill="currentColor" />
    <path className="uh-brand-mark__s" d={S_MARK_PATH} />
  </svg>
);

export default BrandMark;
